import { inject } from 'aurelia-framework'
import { NumeralConverter } from '@dynamik/common';

@inject(NumeralConverter)
export class CleanInputMaskValueConverter {
  constructor(private numeralConverter: NumeralConverter) {
  }

  fromView(val, format) {
    if (format) {
      return this.numeralConverter.parse(val);
    } else {
      return val
    }
  }
}

export class PrecisionValueConverter {
  toView(val, prefix = null) {
    const parsedValue = parseFloat(val);
    if (!isNaN(parsedValue)) {
      if (prefix) {
        return `${prefix}${parsedValue.toFixed(0)}`;
      } else {
        return parsedValue.toFixed(0);
      }
    }

    return val;
  }
}
